export default class StagingArea {

    constructor() {
        this.id = "stagingAreaId";
        this.label = "STG_1";
    }
}



// WEBPACK FOOTER //
// ./src/models/staging-area.js